/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useProjectSharesCacheInvalidator } from './use-project-shares';

/**
 * Update project share.
 */

function updateProjectShare(client: AxiosInstance, projectId: string, shareId: number, role: string): Promise<any> {
  return client
    .patch(resolveAppUrl('projectShareById', { interpolations: { projectId, id: shareId } }), { role })
    .then(({ data }) => data);
}

/**
 * Export `useUpdateProjectShare`.
 */

export function useUpdateProjectShare(projectId: string) {
  const client = useRequestProvider();
  const invalidator = useProjectSharesCacheInvalidator(projectId);

  return useMutation({
    mutationFn: async ({ shareId, role }: { shareId: number; role: string }) => {
      const result = await updateProjectShare(client, projectId, shareId, role);

      await invalidator();

      return result;
    }
  });
}
